import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Select } from "ui";

import {
  AdditionalAttributesBlockProps,
  ProductFormValues
} from "../ProductDetailsForm.types";

import styles from "../ProductDetailsForm.module.scss";

export const AdditionalAttributesBlock = ({
  additionalAttributes
}: AdditionalAttributesBlockProps) => {
  const { t } = useTranslation();
  const { control } = useFormContext<ProductFormValues>();

  return (
    <div className={styles.productForm__block}>
      <h4 className={styles.productForm__block__title}>
        {t("Additional attributes")}
      </h4>

      <div className={styles.productForm__block__selectors}>
        {additionalAttributes.map((attribute, index) => (
          <Controller
            key={attribute.id}
            control={control}
            defaultValue={{
              attributeId: attribute.id as string,
              valueId: null
            }}
            name={`additionalAttributesValuesIds.${index}`}
            render={({ field: { value, onChange } }) => (
              <Controller
                control={control}
                name={`additionalAttributesValuesIds.${index}.valueId`}
                render={({ fieldState: { error } }) => (
                  <Select
                    value={value.valueId}
                    label={attribute.name}
                    placeholder={t("Choose value")}
                    onChange={(selectedValue) => {
                      onChange({
                        attributeId: attribute.id as string,
                        valueId: selectedValue
                      });
                    }}
                    options={attribute.values.map((attValue) => ({
                      label: attValue.value,
                      value: attValue.id as string
                    }))}
                    errorMessage={error?.message}
                  />
                )}
              />
            )}
          />
        ))}
      </div>
    </div>
  );
};
